import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { get } from 'lodash';

import { openLoginModal, openRegisterModal } from '../../../../../parts/ui/uiActions';
import { updateMember, updateMemberProfile } from '../../../../../member/memberActions';
import { updateSessionState } from 'Parts/session/sessionActions';

import UserInformationCards from './UserInformationCards';

const mapStateToProps = state => ({
  platform: get(state, 'platform.platform'),
  organization: get(state, 'organization.organization'),
  countries: get(state, 'geo.countries'),
  provinces: get(state, 'geo.provinces'),
  infos: get(state, 'donation.donationInformation'),
  user: get(state, 'session.user'),
  userTypeId: get(state, 'session.userTypeId'),
  locale: get(state, 'session.language')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  openLoginModal,
  openRegisterModal,
  updateMember,
  updateMemberProfile,
  updateSessionState
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create()
)(UserInformationCards);
